<template>
  <b-container v-if="this.type" fluid>
    <h1>{{title || $appConfig.models[this.type].title}} <b-button v-if="$appConfig.models[this.type].allowNew" variant="secondary" size="sm" :to="'/new/' + type" v-translate>+ NEW</b-button></h1>
    <b-card no-body class="filters">
      <b-tabs card v-model="tabIndex">
        <b-tab :title="$gettext('Quick Filters')" active>
          <b-card-text>
            <b-row>
              <b-col class="text-center filter-actions">
                <b-badge size="md" @click="resetQuickFilters" v-translate>Reset Filters</b-badge> <b-badge size="sm" @click="saveCurrentQuickFilters" v-translate>Save this Filters' Set</b-badge>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6" md="2">
                <b-form-group>
                  <label for="filter-roles" v-translate>Roles</label>
                  <b-form-checkbox-group stacked id="filter-roles" v-model="filter.roles" :options="rolesSelect"></b-form-checkbox-group>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <div class="form-group">
                  <label for="filter-user-id" v-translate>User ID</label>
                  <input id="filter-user-id" v-model.lazy="filter.userId" type="text" class="mb-2 col-12 form-control">
                </div>
                <div class="form-group">
                  <label for="filter-name" v-translate>Name</label>
                  <input id="filter-name" v-model.lazy="filter.userName" type="text" class="mb-2 col-12 form-control">
                </div>
                <div class="form-group">
                  <label for="filter-tin" v-translate>User TIN</label>
                  <input id="filter-tin" v-model.lazy="filter.userTin" type="text" class="mb-2 col-12 form-control">
                </div>
              </b-col>
              <b-col md="3">
                <div class="form-group">
                  <label for="filter-email" v-translate>Email</label>
                  <input id="filter-email" v-model.lazy="filter.userEmail" type="text" class="mb-2 col-12 form-control">
                </div>
                <div class="form-group">
                  <label for="filter-phone" v-translate>Phone</label>
                  <input id="filter-phone" v-model.lazy="filter.userPhone" type="text" class="mb-2 col-12 form-control">
                </div>
                <b-form-group>
                  <label for="filter-enabled" v-translate>User Status</label>
                  <b-form-radio-group stacked id="filter-enabled" v-model="filter.enabled" :options="[{text: $gettext('All'), value: null}, {text: $gettext('Enabled'), value: 1}, {text: $gettext('Disabled'), value: false}]"></b-form-radio-group>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group><br>
                  <company-autocomplete ref="companyAc" @selected="onSearchCompanySelected" />
                  <b-badge v-for="(item, index) in filter.company" :key="index">
                    {{ item.name }} <b-badge variant="danger" href="#" @click.prevent="removeCompanyFromFilters(index)">×</b-badge>
                  </b-badge>&nbsp;
                </b-form-group>
                <div class="form-group">
                  <tag-autocomplete ref="tagAc" @selected="onSearchTagSelected" />
                  <b-badge v-for="(item, index) in filter.tag" :key="index">
                    {{ item.name }} <b-badge variant="danger" href="#" @click.prevent="removeTagFromFilters(index)">×</b-badge>
                  </b-badge>&nbsp;
                </div>
              </b-col>
            </b-row>
          </b-card-text>
        </b-tab>
        <b-tab :title="$gettext('Advanced Filters')">
          <b-card-text>
            <b-row>
              <b-col lg="12" class="my-1">
                <listing-filter :type="type" @save-filter="saveCurrentAdvancedFilters" :filter-fields="filterFields" :pre-filters="preFilters" @refresh="refreshTable" ref="listingFilters" />
              </b-col>
            </b-row>
          </b-card-text>
        </b-tab>
        <b-tab :title="$gettext('Saved Filters')" :disabled="savedUsersQuickSearches.length === 0">
          <b-list-group>
            <b-list-group-item v-for="(savedQuickSearch, index) in savedUsersQuickSearches" :key="index" :href="savedQuickSearch.url" class="d-flex justify-content-between align-items-center">
              {{ savedQuickSearch.name }}
              <b-badge href="#" @click.stop.prevent="deleteSavedQuickSearch(index)" variant="danger">✕</b-badge>
            </b-list-group-item>
          </b-list-group>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-row class="mb-3">
      <b-col>
      </b-col>
      <b-col cols="12" sm="3" lg="2">
        <b-form-group horizontal :label="$gettext('Per page')" :label-cols="6" class="text-right mb-0">
          <b-form-select  cols="6" :options="pageOptions" v-model="perPage" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="bg-white py-1" v-translate="{totalRows: totalRows || '-'}">
        Total items: <strong>%{totalRows}</strong>
      </b-col>
    </b-row>
    <b-table id="my-table" stacked="md" foot-clone :total-rows="totalRows" :sort-desc="sortDesc" :sort-by="sortBy" :per-page="perPage" :current-page="currentPage" :busy.sync="isBusy" :items="myProvider" :fields="fields" :api-url="this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint" :filter="applyFilter">

      <div slot="table-busy" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong v-translate>Loading...</strong>
      </div>

      <template v-slot:cell(id)="data">
        <div v-if="data.item.ecosystem !== 'external'">
          <a :href="'/edit/' + type + '/' + data.value">
            {{data.value | uuid }}
          </a>
          <a href="#" @click.prevent="copyToClipboard(data.value)" class="text-secondary" :title="$gettext('Copy to Clipboard')">
            <font-awesome-icon :icon="['far', 'copy']" size="1x" />
          </a>
        </div>
        <div v-else>
          <b-badge variant="dark" v-translate>External</b-badge>
          <b-badge variant="danger" v-if="data.item.restricted_to_own_ecosystem === true" v-translate>BLOCKED</b-badge>
        </div>
      </template>

      <template v-slot:cell(profile_picture)="row">
        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="rounded" v-b-tooltip.html
        :title="'<img src=data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII= style=\'background: transparent url(' + (row.item.profile_picture || 'https://www.gravatar.com/avatar/default?s=150&r=pg&d=mm') + ') no-repeat 50% 50%/cover;\' width=150 height=150 />'" :style="'display: inline-block; width: 50px; height: 50px; background: transparent url(' + (row.item.profile_picture || 'https://www.gravatar.com/avatar/default?s=50&r=pg&d=mm') + ') no-repeat 50% 50%/cover;'" alt="Avatar" />
      </template>

      <template v-slot:cell(name)="row">
        <strong>{{row.item.name}}</strong>
        <div v-if="row.item.roles" style="width: 220px;">
          <span v-for="(item, index) in row.item.roles.filter(role => (!isMoova && role.name !== 'super-admin') || isMoova)" :key="index">
            <b-badge variant="dark">{{ item.name }}</b-badge>&nbsp;
          </span>
        </div>
      </template>

      <template v-slot:cell(email)="row">
        <a :href="'mailto://' + row.item.email">{{row.item.email}}</a>
        <div v-if="row.item.tags.length > 0" style="width: 220px;">
          <span v-for="(item, index) in row.item.tags" :key="index">
            <b-badge pill variant="danger">{{ item.name }}</b-badge>&nbsp;
          </span>
        </div>
      </template>

      <template v-slot:cell(phone)="row">
        <div v-if="row.item.phone">
          {{row.item.phone | phone(row.item.country_iso_code)}}<br>
          <a class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" v-if="row.item.phone" :href="'tel://' + row.item.phone" v-translate>Call</a>
          <a class="btn btn-sm btn-secondary" style="padding: 0.1rem 1rem;" v-if="row.item.phone" :href="$options.filters.whatsappize(row.item.phone)">WhatsApp</a>
        </div>
      </template>

      <template v-slot:cell(active)="row" class="text-center">
        <span :title="row.item.active ? $gettext('Enabled') : $gettext('Disabled')" style="display: inline-block; width:15px; height:15px; border-radius: 100px;" :class="row.item.active ? 'bg-success' : 'bg-danger'"></span>
      </template>

      <template v-slot:cell(company_id)="row">
        <div v-if="row.item.company_id">
          <a :href="'/edit/companies/' + row.item.company_id" target="_blank" v-if="row.item.ecosystem !== 'external'">
            #{{row.item.company_id}}
          </a>
          {{row.item.company.name}}
          <div v-if="row.item.company.tags.length > 0" style="width: 220px;">
            <span v-for="(item, index) in row.item.company.tags" :key="index">
              <b-badge pill variant="danger">{{ item.name }}</b-badge>&nbsp;
            </span>
          </div>
        </div>
      </template>

      <template v-slot:cell(updated_at)="row">
        {{moment.utc(row.item.updated_at).tz($tz).format('YYYY-MM-DD')}}<br>
        {{moment.utc(row.item.updated_at).tz($tz).format('HH:mm:ss')}}
      </template>

      <template v-slot:cell(created_at)="row">
        {{moment.utc(row.item.created_at).tz($tz).format('YYYY-MM-DD')}}<br>
        {{moment.utc(row.item.created_at).tz($tz).format('HH:mm:ss')}}
      </template>

      <template v-slot:cell(courier)="row">
        <div v-if="row.item.courier">
          <user-card :user='row.item.courier' :profile-picture="false" :with-titles="false" :vehicle-types-prop="vehicleTypes" />
        </div>
      </template>

      <template v-slot:cell(actions)="row">
        <div v-if="row.item.ecosystem !== 'external'">
          <b-button pill size="sm" @click.stop="row.toggleDetails" style="padding: .5rem">
            <font-awesome-icon v-if="row.detailsShowing" :icon="['far', 'eye-slash']" size="2x" style="font-size: 16px;vertical-align: middle" />
            <font-awesome-icon v-else :icon="['far', 'eye']" size="2x" style="font-size: 16px;vertical-align: middle" />
          </b-button>
        </div>
        <div v-else>
          <b-button pill size="sm" variant="danger" @click.stop="blockUser(row.item)" style="padding: .5rem .65rem" v-if="!row.item.restricted_to_own_ecosystem">
            <font-awesome-icon icon="lock" size="2x" style="font-size: 16px;vertical-align: middle" />
          </b-button>
          <b-button pill size="sm" variant="success" @click.stop="unblockUser(row.item)" style="padding: .5rem .65rem" v-else>
            <font-awesome-icon icon="unlock" size="2x" style="font-size: 16px;vertical-align: middle" />
          </b-button>
        </div>
      </template>

      <template v-slot:row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key" v-if="value && value.length !== 0 && value !== 'undefined' && value !== null">{{ key }}: <span v-html="key.indexOf('phone') === -1 ? isJson(value) : value.toString()"></span></li>
          </ul>
        </b-card>
      </template>

    </b-table>
    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
  </b-container>
</template>

<script>
function initialQuickFilters() {
  return {
    statuses: [],
    userId: '',
    userName: '',
    userTin: '',
    userPhone: '',
    userEmail: '',
    enabled: null,
    company: [],
    tag: [],
    roles: []
  }
}
import AddressAutocomplete from '@/components/autocompletes/AddressAutocomplete'
import ListingFilter from '@/components/ListingFilter'
import CompanyAutocomplete from '@/components/autocompletes/CompanyAutocomplete'
import TagAutocomplete from '@/components/autocompletes/TagAutocomplete'

export default {
  name: 'ApiList',
  components: {
    AddressAutocomplete,
    ListingFilter,
    CompanyAutocomplete,
    TagAutocomplete
  },
  props: {
    type: {
      type: String,
      default: 'users'
    },
    title: {
      type: String
    },
    preFilters: {
      type: Array,
      default: () => {
        return []
      }
    },
    prePerPage: {
      type: Number,
      default: 25
    }
  },
  data () {
    return {
      tabIndex: 0,
      fields: [],
      filterFields: this.$appConfig.models[this.type].filters,
      exclude: this.$appConfig.models[this.type].exclude,
      includes: this.$appConfig.models[this.type].includes || [],
      isBusy: false,
      currentPage: 1,
      perPage: this.prePerPage,
      totalRows: null,
      pageOptions: [ 10, 25, 50, 100, 500 ],
      sortBy: 'updated_at',
      sortDesc: true,
      sortDirection: 'desc',
      filters: this.preFilters,
      filter: initialQuickFilters(),
      quickFilters: {},
      savedUsersQuickSearches: [],
      companyAcOptions: {
        debounce: 500,
        placeholder: this.$gettext('Company Name, Business Name or TIN'),
        inputClass: 'form-control'
      },
      searchCompanyQuery: '',
      minCharacter: 2,
      searchTagQuery: '',
      tagAcOptions: {
        debounce: 500,
        placeholder: 'Tag name',
        inputClass: 'form-control'
      }
    }
  },
  watch: {
    type: function (val) {
      console.log(this.type)
      console.log(val)
      this.resetData()
      this.$refs.listingFilters.resetData()
      this.fields = this.$appConfig.models[this.type].fields
      this.filterFields = this.$appConfig.models[this.type].filters
      this.exclude = this.$appConfig.models[this.type].exclude
      this.fields.push({ key: 'actions', label: this.$gettext('Actions') })
      let that = this
      this.fields = this.fields.filter(function (obj) {
        if (that.exclude) {
          return that.exclude.indexOf(obj.key) === -1
        } else {
          return true
        }
      })
      this.refreshTable()
    },
    exclude: function (val) {
      return this.$appConfig.models[this.type].exclude
    },
    'filter.roles': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['roles'] = [ 'roles.id', 'in', val ]
        } else {
          this.quickFilters['roles'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.userId': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['userId'] = [ 'id', 'eq', val ]
        } else {
          this.quickFilters['userId'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.userName': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['userName'] = [ 'name', 'ct', val ]
        } else {
          this.quickFilters['userName'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.userTin': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['userTin'] = [ 'tin', 'ct', val ]
        } else {
          this.quickFilters['userTin'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.userEmail': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['userEmail'] = [ 'email', 'ct', val ]
        } else {
          this.quickFilters['userEmail'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.enabled': {
      handler (val) {
        if (val === 1) {
          this.quickFilters['enabled'] = [ 'active', 'eq', 1 ]
        } else if (val === false) {
          this.quickFilters['enabled'] = [ 'active', 'eq', false ]
        } else {
          this.quickFilters['enabled'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.userPhone': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['userPhone'] = [ 'phone', 'ct', val ]
        } else {
          this.quickFilters['userPhone'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.company': {
      handler (val) {
        if (val.length > 0) {
          let companies = val.map(function (item) {
            return item.id
          })
          let companyNames = val.map(function (item) {
            return item.name
          })
          this.quickFilters['company'] = [[ 'company_id', 'in', companies ], companyNames]
        } else {
          this.quickFilters['company'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    },
    'filter.tag': {
      handler (val) {
        if (val.length > 0) {
          let tags = val.map(function (item) {
            return item.name
          })
          this.quickFilters['tag'] = [[ 'userTags', 'in', tags ], tags]
        } else {
          this.quickFilters['tag'] = []
        }
        this.updateQuickFilters()
      },
      deep: true
    }
  },
  computed: {
    applyFilter () {
      return this.filter
    }
  },
  created() {
    this.fetchRoles()
    this.fetchVehicleTypes()
    window.addEventListener('popstate', () => {
      if (this.$route.query.s) {
        this.tabIndex = 1
        this.checkAdvancedFilters()
      } else if (this.$route.query.qs) {
        this.tabIndex = 0
        this.checkQuickFilters()
      }
    })
  },
  mounted() {
    this.resetData()
    this.fields = this.$appConfig.models[this.type].fields
    this.includes = this.$appConfig.models[this.type].includes
    this.exclude = this.$appConfig.models[this.type].exclude
    let that = this
    let fields = this.fields.filter(function (obj) {
      if (that.exclude) {
        return that.exclude.indexOf(obj.key) === -1
      } else {
        return true
      }
    })
    fields.push({ key: 'actions', label: this.$gettext('Actions') })
    this.fields = fields
    if (this.$route.query.s) {
      this.tabIndex = 1
      this.checkAdvancedFilters()
    } else if (this.$route.query.qs) {
      this.checkQuickFilters()
    } else {
      this.refreshTable()
    }
    if (localStorage.savedUsersQuickSearches) {
      this.savedUsersQuickSearches = JSON.parse(localStorage.savedUsersQuickSearches)
    }
  },
  methods: {
    checkAdvancedFilters() {
      // this.quickFilters = []
      if (this.$route.query.s) {
        this.advancedFilters = JSON.parse(this.$route.query.s)
        this.$refs.listingFilters.filters = this.advancedFilters
        console.log(this.advancedFilters)
      }
      this.refreshTable(this.advancedFilters)
    },
    checkQuickFilters() {
      this.advancedFilters = []
      this.$refs.listingFilters.resetData()
      if (this.$route.query.qs) {
        this.quickFilters = JSON.parse(this.$route.query.qs)
        Object.keys(JSON.parse(this.$route.query.qs)).forEach(function (key) {
          if (this.quickFilters[key].length > 2) {
            this.filter[key] = this.quickFilters[key][2]
          } else if (this.quickFilters[key].length === 2) {
            this.filter[key] = []
            for (let i = 0; i < this.quickFilters[key][0][2].length; i++) {
              this.filter[key].push({id: this.quickFilters[key][0][2][i], name: this.quickFilters[key][1][i], email: this.quickFilters[key][1][i]})
            }
          }
        }.bind(this))
        this.updateQuickFilters()
      }
    },
    updateQuickFilters() {
      if (this.tabIndex === 0) {
        this.currentPage = 1
        let filters = []
        Object.values(this.quickFilters).forEach(function (filter) {
          if (filter.length === 2) {
            filters.push(filter[0])
          } else {
            filters.push(filter)
          }
        })
        if (filters.length > 0) {
          this.$router.push({ query: {qs: JSON.stringify(this.quickFilters)} })
        }
        this.refreshTable(filters)
      }
    },
    resetQuickFilters: function () {
      Object.assign(this.$data.filter, initialQuickFilters())
      this.updateQuickFilters()
    },
    saveCurrentQuickFilters() {
      let name = prompt(this.$gettext('Please set a name for this Filters Set'))
      if (name) {
        this.savedUsersQuickSearches.push({name: 'QUICK: ' + name, url: window.location.href})
      } else {
        alert(this.$gettext('You must write a name for this Filters Set'))
      }
      try {
        localStorage.savedUsersQuickSearches = JSON.stringify(this.savedUsersQuickSearches)
      } catch (e) {
        alert(this.$gettext('The Filters couldn\'t be saved'))
      }
      this.savedUsersQuickSearches = JSON.parse(localStorage.savedUsersQuickSearches)
    },
    resetAdvancedFilters: function () {
      this.$refs.listingFilters.resetData()
      this.$refs.listingFilters.emitRefresh()
    },
    saveCurrentAdvancedFilters() {
      let name = prompt(this.$gettext('Please set a name for this Filters Set'))
      if (name) {
        this.savedUsersQuickSearches.push({name: 'ADVANCED: ' + name, url: window.location.href})
      } else {
        alert(this.$gettext('You must write a name for this Filters Set'))
      }
      try {
        localStorage.savedUsersQuickSearches = JSON.stringify(this.savedUsersQuickSearches)
      } catch (e) {
        alert(this.$gettext('The Filters couldn\'t be saved'))
      }
      this.savedUsersQuickSearches = JSON.parse(localStorage.savedUsersQuickSearches)
    },
    deleteSavedQuickSearch(index) {
      this.savedUsersQuickSearches.splice(index, 1)
      localStorage.savedUsersQuickSearches = JSON.stringify(this.savedUsersQuickSearches)
      this.savedUsersQuickSearches = JSON.parse(localStorage.savedUsersQuickSearches)
    },
    myProvider (ctx) {
      console.log(ctx)
      let params = {
        page: ctx.currentPage - 1,
        limit: ctx.perPage,
        includes: this.includes,
        sort: [
          {
            key: ctx.sortBy || 'id',
            direction: ctx.sortDesc ? 'desc' : 'asc'
          }
        ]
      }
      console.log(this.filters)
      if (this.filters || this.preFilters) {
        params.filter_groups = [
          {
            filters: this.filters || this.preFilters
          }
        ]
      }
      console.log(JSON.stringify(params))

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      let promise = this.$http.get(ctx.apiUrl, { params: params })

      return promise.then((data) => {
        const items = data.body.data
        // // Here we could override the busy state, setting isBusy to false
        // // this.isBusy = false
        this.totalRows = data.body.pagination.total
        return (items)
      }).catch(error => {
        console.log(error)
        // Here we could override the busy state, setting isBusy to false
        // this.isBusy = false
        // Returning an empty array, allows table to correctly handle busy state in case of error
        return []
      })
    },
    refreshTable (filters) {
      console.log(filters)
      this.filters = filters
      setTimeout(() => {
        this.$root.$emit('bv::refresh::table', 'my-table')
      }, 100)
    },
    resetData: function () {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    onSearchCompanySelected(item) {
      this.filter.company.push({id: item.id, name: item.name})
      this.$refs.companyAc.searchQuery = ''
    },
    removeCompanyFromFilters(index) {
      this.filter.company.splice(index, 1)
    },
    onSearchTagSelected(item) {
      this.filter.tag.push({name: item.name})
      this.$refs.tagAc.searchQuery = ''
    },
    removeTagFromFilters(index) {
      this.filter.tag.splice(index, 1)
    },
    blockUser(user) {
      if (confirm(this.$gettext('Are you sure you want to BLOCK the user from Moova?'))) {
        let payload = {
          restricted_to_own_ecosystem: true
        }
        this.$http.patch(this.$appConfig.api.baseUrl + 'ecosystems/users/' + user.id, payload)
          .then(() => {
            this.refreshTable()
          })
      }
    },
    unblockUser(user) {
      if (confirm(this.$gettext('Are you sure you want to UNLOCK the user for Moova shippings?'))) {
        let payload = {
          restricted_to_own_ecosystem: false
        }
        this.$http.patch(this.$appConfig.api.baseUrl + 'ecosystems/users/' + user.id, payload)
          .then(() => {
            this.refreshTable()
          })
      }
    }
  }
}
</script>
